import { createFileRoute } from '@tanstack/react-router'
import { PointCloudHomeContent } from 'pages/pointClouds/components/home/PointCloudHomeContent'

export const Route = createFileRoute('/point-cloud/$siteID/')({
  component: PointCloudHomeContent,
  staticData: {
    title: 'Point Clouds',
  },
})
